// extracted by css-extract-rspack-plugin
export default {"root":"global-module__root__nNmVM"};